import HyperLink from "./reusables/HyperLink";

function Footer() {
    return (
        <>
            <div className="footer">
                <div className="footerSectionOne">
                    <h1><span id="palm-highlight">Palm</span><br></br>Digitalz</h1>
                </div>
                <div className="footerSectionTwo">
                    <h3>Products</h3>
                    <HyperLink
                        link={{
                            url: "https://palmdigitalz.online",
                            target: "_blank",
                            displayText: "Palm 360™"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/palm-key",
                            target: "_self",
                            displayText: "Palm Key™"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/palm-ark",
                            target: "_self",
                            displayText: "Palm Ark™"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/palm-ray",
                            target: "_self",
                            displayText: "Palm Ray™"
                        }}
                    />
                </div>
                <div className="footerSectionThree">
                    <h3>Services</h3>
                    <HyperLink
                        link={{
                            url: "/modernization-assessment",
                            target: "_self",
                            displayText: "Modernization Assessment"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/reverse-engineering",
                            target: "_self",
                            displayText: "Reverse Engineering"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/training",
                            target: "_self",
                            displayText: "Modernization Training"
                        }}
                    />
                </div>
                <div className="footerSectionFour">
                    <h3>Other Links</h3>
                    <HyperLink
                        link={{
                            url: "/newsroom",
                            target: "_self",
                            displayText: "Newsroom"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/company",
                            target: "_self",
                            displayText: "The Company"
                        }}
                    />
                    <br />
                    {/* <HyperLink
                        link={{
                            url: "/newsroom#socials",
                            target: "_self",
                            displayText: "Socials"
                        }}
                    />
                    <br />
                    <HyperLink
                        link={{
                            url: "/#contact",
                            target: "_self",
                            displayText: "Contact"
                        }}
                    /> */}
                    <br />
                </div>
            </div>
            <div className="credit">
  <p>
    Copyright © {new Date().getFullYear()} <span id="creditCompany">Let Us Support Pvt. Ltd. |</span> All rights reserved | 
    <span id="country"><strong> India</strong></span>
  </p>
</div>

        </>
    );
}

export default Footer;
